import React from 'react';
import './Mentorship.css'

const Mentorship = () => {
  return <div className='mentorship'>
  <h2>MENTORSHIP PROGRAM</h2>
      <div className="container">
        
      <p>
      This program is open all throughout and it emphasises on the concept of clearing all your queries pertaining to how to get started in the technical or non technical field, the various options to explore in the technical and non technical domain and placement related queries to the accessible seniors of the college. Just fill up the Google Form given and you will be connected to the suitable mentor.
      </p>
      <br /><a href="https://docs.google.com/forms/d/e/1FAIpQLSegcIFNJAkuKV4AHtZ2ZqzHC5vUmSr1BKk9C6gfF-wiCj-WaQ/viewform"><button>Click here to register</button></a>
      </div>
  </div>;
};

export default Mentorship;
